export default __webpack_public_path__ + "static/media/watchlist-icon.88dc6574.svg";